import type { Guard } from './index';

const debugRoutes: Guard = (to, from, next) => {
  if (import.meta.env.DEV) return next();
  const env = (import.meta.env.VUE_URL_DOMAIN as string) ?? '';
  if (['dev.br', 'net.br'].some(d => env.includes(d))) return next();
  return next('/');
};

export default debugRoutes;
